import { getCookie, setCookie } from './cookies';

export function hasStorage() {
	const testKey = 'test';
	const storage = window.localStorage;
	try {
		storage.setItem(testKey, '1');
		storage.removeItem(testKey);
		return true;
	} catch (error) {
		return false;
	}
}

export function getValue(key, storage = 'local') {
	if (storage === 'cookie') {
		return getCookie(key);
	}
	return localStorage.getItem(key);
}

export function setValue(key, value, storage = 'local') {
	if (storage === 'cookie') {
		const expiry = new Date().getTime() + 365 * 24 * 60 * 60 * 100;
		setCookie(key, value, expiry);
	} else {
		localStorage.setItem(key, value);
	}
}

export function setValueWithExpiry(key, value, storage = 'local', ttl) {
	const now = new Date();
	const currentTimeStamp = now.getTime();
	const expiry = currentTimeStamp + ttl;
	if (storage === 'cookie') {
		setCookie(key, value, expiry);
	} else {
		const item = {
			value,
			expiry
		};
		localStorage.setItem(key, JSON.stringify(item));
	}
}

export function getValueWithExpiry(key, storage = 'local') {
	if (storage === 'cookie') {
		return getCookie(key);
	}
	// get from localStorage and check for expiration
	const itemStr = localStorage.getItem(key);
	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = new Date();
	// checking expiry time with current time
	if (now.getTime() > item.expiry) {
		// access token has expired now clear storage
		localStorage.removeItem(key);
		return null;
	}
	return item.value;
}
